import { addMonths, endOfDay, endOfMonth, isBefore, setDate, setHours, startOfDay } from 'date-fns';

import { estimateCorporateDonationProcessedAt } from 'utils/estimateCorporateDonationProcessedAt';
import type Organization from 'entities/organization/model';

/**
 * @NOTE-AC:
 * This is duplicated with https://github.com/joindeed/marketplace/blob/9af1147af81783734db4f985be60af5a26f19e21/packages/mongoose-models/src/utils/estimateDonationDisbursedAt.ts
 * Try keeping them in sync!
 */
export const estimateCorporateDonationDisbursedAt = (
  provider: string,
  nonprofit: Organization,
  referenceDate = estimateCorporateDonationProcessedAt(provider)
) => {
  if (!referenceDate) {
    return undefined;
  }

  if (provider === 'PayPal') {
    if (nonprofit?.locationObject?.countryCode === 'US') {
      // @NOTE-AC: [sc-44124] If the processing happened before the 16th...
      return isBefore(referenceDate, startOfDay(setDate(referenceDate, 16)))
        ? setHours(endOfDay(setDate(referenceDate, 25)), 11)
        : setHours(endOfDay(setDate(addMonths(referenceDate, 1), 25)), 11);
    }

    // @NOTE-RT: Paid out at the end of the _next_ month
    return setHours(endOfMonth(addMonths(referenceDate, 1)), 11);
  }

  // @NOTE-RT: This isn't so much NFG as it is _unenrolled PPGF US_
  if (provider === 'NFG') {
    // @NOTE-RT: Paid out at the end of the third month after the reference date per http://github.com/joindeed/api/blob/14f4c88818c33f8dccbdcc34c9ec1b19bb19f19a/server/api/donation/estimateDonationMatchDisbursedAt.js#L19-L19
    return setHours(endOfMonth(addMonths(referenceDate, 3)), 11);
  }

  if (provider === 'GlobalGiving') {
    // @NOTE-RT: Paid out on the 25th of the _next_ month
    return setHours(endOfDay(setDate(addMonths(referenceDate, 1), 25)), 11);
  }

  if (provider === 'Stripe') {
    // @NOTE-RT: Paid out on the 25th of the _next_ month
    return setHours(endOfDay(setDate(addMonths(referenceDate, 1), 25)), 11);
  }

  if (provider === 'External') {
    return undefined;
  }

  if (provider === 'Betterplace') {
    return undefined;
  }

  if (provider === 'DCGF') {
    return undefined;
  }

  console.warn(
    `Can't estimateCorporateDonationDisbursedAt for provider:${provider} and nonprofit:${nonprofit.id}`
  );

  return undefined;
};

export default estimateCorporateDonationDisbursedAt;
